import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StorageUsage',
  setup(__props) {

const REFRESH_STORAGE = 5500;
const avail = ref(4);
const used = ref(1);

const percent = computed(() => {
  if (avail.value === 0) {
    return 0;
  }
  const percentage = (used.value / avail.value) * 100;

  return Math.min(100, Math.round(percentage));
});
function updateUsage() {
  navigator.storage?.estimate().then(({ usage, quota }) => {
    console.log(quota, usage);
    avail.value = quota;
    used.value = usage;
  });
}
onMounted(() => {
  updateUsage();
  setInterval(() => updateUsage, REFRESH_STORAGE);
});

return { __sfc: true,REFRESH_STORAGE, avail, used, percent, updateUsage }
}

})